import { render } from "./TrialFunnelPanel.vue?vue&type=template&id=2087544f&scoped=true"
import script from "./TrialFunnelPanel.vue?vue&type=script&lang=js"
export * from "./TrialFunnelPanel.vue?vue&type=script&lang=js"

import "./TrialFunnelPanel.vue?vue&type=style&index=0&id=2087544f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2087544f"]])

export default __exports__